export default {
  title: "",
  subtitle: "Payout",
  path: "payout_pse",
  paragraphs: [
    "After registering your customer bank account with us, you will be able to pay them locally using the following endpoint. We will use the Bank details you registered with us.",
    "The payout transactions can be initiated within your foreign currency cash-out account or your Colombian cash-out account.",
    "*If you prefer to do a payout with the full value already in local currency, please refer to section 'Reverse Exchange' of this documentation. "
  ],
  request: {
    method: "POST",
    endpoint: "/transactions",
    payload:{ 
        "transaction": { 
            "currency": "USD or COP", 
            "exchange_currency": "COP", 
            "value": "500.00", 
            "from_bank_account_id": "your USD/COP cash-out internal account id", 
            "to_bank_account_id": "the id of your customer bank account", 
            "subject_id": "your customer id" 
        } 
      },
    responses: {
      "data": {
        "value": "500.00",
        "to_bank_account": {
          "routing_number": null,
          "pix_info": null,
          "owner_name": "Carlos Jose",
          "owner_document_type": "cc",
          "owner_document_number": "8001972684",
          "owner_company": {
            "social_name": "Carlos Jose Alvarenga Custodio",
            "id": "5bb4748b-ac59-41a3-8a22-751d49f0f525",
            "document_type": "cc",
            "document_number": "8001972684"
          },
          "nickname": null,
          "intermediary_bank_account": null,
          "id": "50d45ba5-2dc4-4784-b35b-65443ce9caac",
          "iban": null,
          "currency": "COP",
          "branch_number": "123",
          "branch_country": "COL",
          "bank": {
            "swift": null,
            "name": "Banco Colombia",
            "ispb": null,
            "id": "69185e6c-9a0c-49a4-bc9c-38d0a5ebff05",
            "country": "COL",
            "code": "123"
          },
          "account_type": "conta-corrente",
          "account_number": "1234567890",
          "aba": null
        },
        "subject_is_receiver": true,
        "subject_id": "5bb4748b-ac59-41a3-8a22-751d49f0f525",
        "subject": {
          "updated_at": "2025-07-10T19:16:14.252158",
          "status": "approved",
          "social_name": "Carlos Jose Alvarenga Custodio",
          "rfc_pf": null,
          "required_clearance_level": 1,
          "references": [],
          "phone_number": "9991456",
          "phone_country_code": "57",
          "phone_area_code": "601",
          "net_monthly_average_income": "2000.00",
          "inserted_at": "2025-07-10T19:14:35.558870",
          "id": "5bb4748b-ac59-41a3-8a22-751d49f0f525",
          "fiscal_country": "Colombia",
          "email": "carlos.jose@gmail.com",
          "document_type": "cc",
          "document_number": "8001972684",
          "clearance_level": 1,
          "birth_date": "1996-12-06",
          "address_street": "Rua Moralez Guedes",
          "address_state": null,
          "address_postal_code": "110010",
          "address_number": "125",
          "address_neighborhood": "Center",
          "address_country": "Colombia",
          "address_complement": null,
          "address_city": "Bogota"
        },
        "status": "identified",
        "source_name": "Carlos Jose Alvarenga Custodio",
        "source_document_type": "cc",
        "source_document_number": "8001972684",
        "meta": null,
        "inserted_at": "2025-07-10T19:19:01.919767",
        "id": "0340d8b4-b86b-4fe3-a137-5416d212107e",
        "from_credit_card": null,
        "from_bank_account": {
          "routing_number": null,
          "pix_info": null,
          "owner_name": "Biriweb Serviços de Internet Ltd",
          "owner_document_type": null,
          "owner_document_number": "21958642819",
          "nickname": null,
          "internal": true,
          "intermediary_bank_account_id": null,
          "id": "6b1d3acf-42b7-4f5a-8d9b-1da2766e040b",
          "iban": null,
          "flow_type": "cash_out",
          "currency": "USD",
          "branch_number": null,
          "branch_country": null,
          "bank": {
            "swift": null,
            "name": "Internal",
            "ispb": null,
            "id": "6facab8d-573e-44d0-a4bd-ce2600368263",
            "country": "BRA",
            "code": "999"
          },
          "account_type": "conta-corrente",
          "account_number": null,
          "aba": null
        },
        "for_exchange": true,
        "exchange_under_request": false,
        "exchange_currency": "COP",
        "estimated_value_until_exchange": false,
        "currency": "USD",
        "cleared": true,
        "bank_transaction": {
          "wire_id": null,
          "value": "500.0",
          "spei_reference": null,
          "spei_concepto_de_pago": null,
          "source_type": "TED-PRE",
          "source_name": "Carlos Jose Alvarenga Custodio",
          "source_id": "0340d8b4-b86b-4fe3-a137-5416d212107e",
          "source_document_type": "cc",
          "source_document_number": "8001972684",
          "source_description": "CREDITO POR TED ANTECIPADO",
          "source_branch": null,
          "source_bank_ispb": null,
          "source_bank": null,
          "source_account": null,
          "movement_date": "2025-07-10",
          "iof_value": null,
          "inserted_at": "2025-07-10T19:19:01.940236",
          "id": "82611bf1-9542-483c-8c7c-7289e8888d3d",
          "exchanged_value": null,
          "exchange_rate_spot": null,
          "exchange_rate": null,
          "exchange_id": null,
          "exchange_currency": "COP",
          "exchange_approved": false,
          "currency": "USD"
        }
      }
    }
  },
	parameterPayload: [
    {
      name: "transaction",
      type: "object",
      required: true,
      description: "An object containing all the required values needed"
    },
		{
			name: "transaction.currency",
			type: "string",
			required: true,
			description: "Currency of your internal bank account.",
		}, 
    {
			name: "transaction.exchange_currency",
			type: "string",
			required: true,
			description: "For PSE, always use \"COP\" currency"
		}, {
			name: "transaction.value",
			type: "string",
			required: true,
			description: "Amount to be sent to FacilitaPay or deducted from an internal bank account balance"
		}, {
			name: "transaction.from_bank_account_id",
			type: "string",
			required: true,
			description: "UUID of your internal bank account. Its currency must match the currency informed on the currency attribute"
		}, {
			name: "transaction.to_bank_account_id",
			type: "string",
			required: true,
			description: "Destination bank account UUID. This bank account must be from your Colombian customer"
		}, {
			name: "transaction.subject_id",
			type: "string",
			required: true,
			description: "UUID of your customer, i.e. the owner of the to_bank_account_id"
		},
	],
	footerNotes: '',
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/Transaction/TransactionPSEPayout.js